import {Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spacer, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react"
import moment from "moment";
import { mapDayToThai } from "../../util/calendar_util";

const getDescTim = (time) => {
    if(!time){
        return "ไม่ระบุ"
    }
    else{
        return moment(time, "HH:mm:ss").format("HH:mm")
    }
}


const DiagnosisTimeDelete = ({isDeleteModalOpen, setDeleteModalOpen, selectedDeleteTimetable, handleDeleteTimetable }) => {
    return <>
      <Modal
        size={"2xl"}
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ยืนยันการลบเวลาออกตรวจ</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            คุณต้องการลบเวลาออกตรวจวัน 
            {selectedDeleteTimetable && ` "${mapDayToThai(selectedDeleteTimetable.day)}"`}
            {selectedDeleteTimetable &&  ` เวลาตรวจ ${getDescTim(selectedDeleteTimetable.start_time)}-${getDescTim(selectedDeleteTimetable.end_time)} ใช่หรือไม่?`}
            <Flex direction={"column"}>
                <Flex my={4} justify={"initial"} align={"flex-start"}>
                    <Text minW={"80px"} mr={2} color={"orange.700"} fontWeight={500}>
                        คำแนะนำ:
                    </Text>
                    <Text>
                        {" "}
                        กรณีที่มีการเปลี่ยนเวลาออกตรวจใหม่ เช่นเปลี่ยนเวลาออกตรวจของวัน{selectedDeleteTimetable && ` "${mapDayToThai(selectedDeleteTimetable.day)}"`} จากเดิม 
                        {selectedDeleteTimetable && ` "${mapDayToThai(selectedDeleteTimetable.start_time)}"`}{" "}
                        เป็นเวลา 07:30 ในกรณีนี้ให้ผู้ใช้งานทำการเซ็ต "วันที่สิ้นสุดการตรวจ" เดิม (เพื่อให้รายการตรวจเดิมหายไป) และให้เพิ่มรายการตรวจใหม่ของวัน 
                        {selectedDeleteTimetable && ` "${mapDayToThai(selectedDeleteTimetable.day)}"`}
                        {" "}เช่น
                    </Text>
                </Flex>
                <Table fontSize={12}>
                    <Thead>
                        <Tr>
                            <Th>วันที่ออกตรวจ</Th>
                            <Th>เวลาออกตรวจ</Th>
                            <Th>เวลาสิ้นสุด</Th>
                            <Th>วันที่เริ่มออกตรวจ</Th>
                            <Th>วันที่สิ้นสุดการตรวจ</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <Td>{selectedDeleteTimetable && `${mapDayToThai(selectedDeleteTimetable.day)}`}</Td>
                            <Td>07:00</Td>
                            <Td>17:00</Td>
                            <Td>1 ก.พ 2024</Td>
                            <Td>15 มี.ค 2024</Td>
                        </Tr>
                        <Tr>
                            <Td>{selectedDeleteTimetable && `${mapDayToThai(selectedDeleteTimetable.day)}`}</Td>
                            <Td>09:00</Td>
                            <Td>18:00</Td>
                            <Td>16 ก.พ 2024</Td>
                            <Td>ไม่ระบุ</Td>
                        </Tr>
                    </Tbody>
                </Table>
            </Flex>
          </ModalBody>
          <ModalFooter bgColor={"gray.200"}>
            <Flex w="100%" justify={"space-between"}>
              <Button mr={2} colorScheme="red" onClick={handleDeleteTimetable}>
                ลบวันออกตรวจ
              </Button>
              <Spacer />
              <Button variant="ghost" onClick={() => setDeleteModalOpen(false)}>
                ยกเลิก
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
}

export default DiagnosisTimeDelete;